var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuzel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9911"
    },
    points: "11.084,370.598 11.084,353.719 256.001,212.317 500.916,353.719 500.916,370.598  256.001,512 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#F18700"
    },
    d: "M382.247,336.943l-77.291-310.99h-0.009 c-0.941-6.455-5.655-12.757-14.162-17.669c-19.131-11.045-50.435-11.045-69.566,0c-8.507,4.912-13.222,11.214-14.162,17.669h-0.009 l-77.292,310.99c-9.104,24.084,2.475,50.31,34.74,68.938c50.328,29.057,132.683,29.057,183.012,0 C379.77,387.253,391.35,361.026,382.247,336.943z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#F18700"
    },
    d: "M382.247,336.943l-77.291-310.99h-0.009 c-0.941-6.455-5.655-12.757-14.162-17.669c-19.131-11.045-50.435-11.045-69.566,0c-8.507,4.912-13.222,11.214-14.162,17.669h-0.009 l-77.292,310.99c-9.104,24.084,2.475,50.31,34.74,68.938c50.328,29.057,132.683,29.057,183.012,0 C379.77,387.253,391.35,361.026,382.247,336.943z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F18700"
    },
    points: "256.001,495.121 256.001,512 11.084,370.598 11.084,353.719 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D07400"
    },
    points: "256.001,495.121 256.001,512 500.916,370.598 500.916,353.719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9911"
    },
    d: "M221.218,48.448c-19.131-11.045-19.131-29.119,0-40.164s50.435-11.045,69.566,0 c19.131,11.045,19.131,29.119,0,40.164C271.653,59.493,240.348,59.493,221.218,48.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D07400"
    },
    d: "M235.13,40.415c-11.478-6.627-11.478-17.471,0-24.098s30.261-6.627,41.74,0 c11.478,6.627,11.478,17.471,0,24.098S246.609,47.042,235.13,40.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E2"
    },
    d: "M362.967,259.374l-26.3-105.819c-3.277,2.736-7.004,5.342-11.215,7.773 c-38.2,22.054-100.708,22.054-138.907,0c-4.211-2.431-7.937-5.037-11.215-7.774l0,0l-26.3,105.819 c5.071,5.56,11.202,10.804,18.412,15.594c48.705,32.36,128.406,32.36,177.111,0C351.765,270.178,357.898,264.933,362.967,259.374z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuzel);
export default __webpack_public_path__ + "static/media/kuzel.cd86442494fd68421d457849ff86672c.svg";
export { ForwardRef as ReactComponent };